"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var seamless_immutable_1 = require("seamless-immutable");
var FEATURE_FLAGS_FETCHED = 'FEATURE_FLAGS_FETCHED';
exports.allFlagsUpdated = function (featureFlags) { return ({
    type: FEATURE_FLAGS_FETCHED,
    payload: featureFlags
}); };
var FEATURE_FLAGS_UPDATED = 'FEATURE_FLAGS_UPDATED';
exports.singleFlagUpdated = function (key, value) { return ({
    type: FEATURE_FLAGS_UPDATED,
    payload: { key: key, value: value }
}); };
function featureFlagReducer(initialState) {
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        if (action.type === FEATURE_FLAGS_FETCHED) {
            return seamless_immutable_1.from(action.payload);
        }
        if (action.type === FEATURE_FLAGS_UPDATED) {
            var _a = action.payload, key = _a.key, value = _a.value;
            return state.set(key, value === true);
        }
        return state;
    };
}
exports.featureFlagReducer = featureFlagReducer;
